<template>
<div class="w-100">
	<div class="import-beneficiarios px-4 w-100 mt-4">
		<div class="import-beneficiarios-items">
			<div class="title">
				<div class="sub-title">
					<DynamicIcon icon="pencil" :classString="'container-modal-title-icon mr-2'"/>
					<span class="sub-title">Corrigir erros na base</span>
				</div>
				<span>
					<b-button pill class="btn-base outline-primary-btn optum-bold" @click="downloadLinhasInvalidas">Baixar linhas inválidas</b-button>
				</span>
			</div>
			<BeneficiarioImportacaoFiltro @filter="filtrar" />
			<div class="importing-box ">
				<div class="table-container">
					<div class="ml-3 p-0 d-flex justify-content-between">
						<b-form-checkbox @input="selecionarTodas" value="true">Selecionar todas</b-form-checkbox>
						<b-button pill class="btn-base primary-btn optum-bold" @click="modalExcluirLinhas">Excluir linhas</b-button>
					</div>
					<b-table id="beneficiarios-temp" striped responsive :items="rows" :fields="headerFields">
						<template #cell(id)="row">
							<p >
								<b-form-checkbox v-model="checkedLines" :id="`row_${row.item.id.line}`" :value="row.item.id.line"/>
							</p>
						</template>
						<template #cell(status)="row">
							<p :class="`status ${getStatusClass(row.item)}`">
								{{getStatusLabel(row.item)}}
							</p>
						</template>
						<template v-slot:cell(errors)="{ item }">
							{{extractFieldErrors(item.errors)}}
						</template>
						<template #cell(actions)="row">
							<ButtonContainer>
								<ButtonEditTable :id="row.item.id.line" titleTooltip="Editar linha" @click="rowEditionId = row.item.id"/>
								<ButtonRemoveUserTable :id="row.item.id.line" titleTooltip="Excluir linha" @click="rowDelete(row.item.id)" />
							</ButtonContainer>
						</template>
					</b-table>
					<b-pagination pills v-model="page" :total-rows="totalItens" :per-page="pageSize" size="sm" align="center" aria-controls="beneficiarios-temp"></b-pagination>
				</div>
			</div>
		</div>
		<div class="editar-importacao-footer">
			<b-button pill class="btn-base outline-primary-btn mr-4 optum-bold" @click="$bvModal.show('cancelar-import-beneficiario')">Cancelar a validação</b-button>
			<b-button pill class="btn-base primary-btn mr-2 optum-bold" @click="ativarImportacao">Continuar a importação</b-button>		
		</div>
		<ModalImportacaoBeneficiarioForm :importacaoId="rowEditionId.importacaoId" :line="rowEditionId.line" 
		v-if="rowEditionId"
		@close="rowEditionId = null" @updated="updateHandler" />

		<b-modal id="excluir-linha-importacao" centered hide-header
        header-class="deletar-perfil-sub-header" body-class="deletar-perfil-body">
            <DynamicIcon icon="exclamation" :classString="'alert-exclamation'"/>
            Deseja remover o beneficiário?
			<template #modal-footer>
                <b-button pill class="btn-base outline-primary-btn optum-bold" @click="$bvModal.hide('excluir-linha-importacao')">Não</b-button>
                <b-button pill class="btn-base primary-btn optum-bold" @click="excluirLinha">Sim</b-button>
            </template>	
        </b-modal>

		<b-modal id="editar-importacao-continue-error" centered hide-header
        header-class="deletar-perfil-sub-header" body-class="deletar-perfil-body" no-close-on-backdrop no-stacking no-close-on-esc>
            <DynamicIcon icon="not" classString="icons-svg"/>
			<p class="text-modal">Ainda existem alguns beneficiários inválidos. Por favor, realize a correção.</p>
			<template #modal-footer>
				<div class="corrigir-importacao-button">
					<b-button pill class="btn-base primary-btn optum-bold" @click=" $bvModal.hide('editar-importacao-continue-error')">Corrigir</b-button>
				</div>
            </template>	
        </b-modal>

		<b-modal id="excluir-multiplas-linhas-importacao" centered hide-header
        header-class="deletar-perfil-sub-header" body-class="deletar-perfil-body">
            <DynamicIcon icon="exclamation" :classString="'alert-exclamation'"/>
            Tem certeza que deseja excluir as linha(s) selecionada(s)?
			<template #modal-footer>
                <b-button pill class="btn-base outline-primary-btn" @click="$bvModal.hide('excluir-multiplas-linhas-importacao')">Não</b-button>
                <b-button pill class="btn-base primary-btn" @click="excluirLinhas">Sim</b-button>
            </template>	
        </b-modal>

	</div>
</div>
	
</template>

<script>
import ButtonContainer from "@/components/commons/table/components/ButtonContainer.vue";
import ButtonEditTable from "@/components/commons/table/components/ButtonEditTable.vue";
import ButtonRemoveUserTable from "@/components/commons/table/components/ButtonRemoveUserTable.vue";
import ModalImportacaoBeneficiarioForm from "./ModalImportacaoBeneficiarioForm"
import BeneficiarioImportacaoFiltro from "./BeneficiarioImportacaoFiltro"
import BeneficiarioImportacaoResource from "@/resources/BeneficiarioImportacaoResource"
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";
import headerFields from "../config/header-colunas"

let columnsKeys = [
	"id",
	"status",
    "nome",
	"cpf",
	"tipoBeneficiario",
    "cnpjFaturamento",
	"errors"
]


export default {
	name: "EditarBeneficiarioImportacaoList",
	components: {
		ButtonContainer,
		ButtonEditTable,
		ButtonRemoveUserTable,
		ModalImportacaoBeneficiarioForm,
		BeneficiarioImportacaoFiltro,
		DynamicIcon,
	},
	props: {
		importacao: Object
	},
	data() {
		return {
			headerFields: [
				{key: "id", label: ""},
				{key: "status", label: "Status"},
				{key: "nome", label: "Nome", thStyle: { width: "35%" }},
				...headerFields.filter(head => columnsKeys.includes(head.key)),
				{key: 'errors', label: 'Erros'},
				{key: "actions", label: "Ações", thStyle: { width: "10%" }}
			],
			lastFilter: {},
			rows: [],
			checkedLines: [],
			page: 1,
			totalItens: null,
			totalPages: null,
			pageSize: null,
			rowEditionId: null,
			rowDeleteId: null
		};
	},
    methods: {
		getLabel(key) {
			const result = headerFields.find(field => field.key == key)
			if(result)
				return result.label
		},
		updateHandler() {
			this.rowEditionId = null
			this.filtrar(this.lastFilter)
		},
		filtrar(formFilter) {
			this.lastFilter = {...formFilter}

			let filter = {
				page: this.page,
				...formFilter
			}

			BeneficiarioImportacaoResource.filtrar(this.importacao.id, filter, {showLoader: true})
			.then((result) => {
				result.list.forEach(row => {
					row.line = row.id.line
				})

				this.rows = result.list
				this.totalItens = result.totalItens
				this.totalPages = result.totalPages
				this.pageSize = result.pageSize
			})
		},
		getStatusClass(item) {
			if(item.updated != null)
				return "alterado"

			if (item.status == "INVALID")
				return "invalid"

			if (item.status == "PRE_IMPORTING")
				return "valid"

			return ""
		},
		getStatusLabel(item) {

			if(item.updated != null)
				return "Alterado"

			if (item.status == "INVALID")
				return "Inválido"

			if (item.status == "PRE_IMPORTING")
				return "Válido"

			return item.status
		},
		ativarImportacao() {
			BeneficiarioImportacaoResource.ativarImportacao(this.importacao.id, {showLoader: true})
			.then((importacao) => {
				if(importacao.errors == 'invalid_validate_lines'){
					this.$bvModal.show('editar-importacao-continue-error')
					return
				}

				this.$emit("updateImportacao", importacao)
			})
		},
		downloadLinhasInvalidas() {
			BeneficiarioImportacaoResource.downloadLinhasInvalidas(this.importacao.id)
		},
		rowDelete(id) {
			this.rowDeleteId = id
			this.$bvModal.show('excluir-linha-importacao')     
		},
		excluirLinha() {
			BeneficiarioImportacaoResource.deleteLineImportacao(this.rowDeleteId.importacaoId, this.rowDeleteId.line, {showLoader: true})
			.then(() => {
				this.$bvModal.hide('excluir-linha-importacao') 
				this.filtrar(this.lastFilter)
			})
		},
        extractFieldErrors( data ) {
            data = JSON.parse(data); // Converte a string em um objeto JavaScript

            if (data && data.fieldErrors) {
				let result = [];
				for(let elem in data.fieldErrors ) {
					let label = this.getLabel(elem)
					if(label)
						result.push(label+ " obrigatório")
				}
				return result.join("; ");
            } else {
                return [];
            }
        },
		modalExcluirLinhas() {
			this.$bvModal.show('excluir-multiplas-linhas-importacao')
		},
		excluirLinhas() {
			let importacaoId = this.rows[0].id.importacaoId;
			BeneficiarioImportacaoResource.deleteLinesImportacao(importacaoId, this.checkedLines, {showLoader: true})
			.then(() => {
				this.checkedLines = [];
				this.$bvModal.hide('excluir-multiplas-linhas-importacao') 
				this.filtrar(this.lastFilter)
			})
		},
		selecionarTodas(value) {
			this.checkedLines = [];
			if(value)
				this.rows.map(row => this.checkedLines.push(row.id.line))
		}
    },
	watch: {
		page() {
			this.filtrar(this.lastFilter)
		},
	}
}
</script>

<style scoped>

.import-beneficiarios {
	justify-content: space-between;
    color: #707070;
	font-size: 18px;
	text-align: left;
    background-color: #fff;
	width: 70%;
}

.import-beneficiarios .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 2.1px;
    color: #002677;
}

.import-beneficiarios .title .ativar-importacao {
	font-weight: bold !important;
	background-color: #002677;
}

.import-beneficiarios .title span .btn {
	margin-left: 5px;
}

.sub-title {
	font-family: optum-sans-bold !important;
	color: #002677 !important;
	font-size: 24px;
	font-weight: 700;
	line-height: 24px;
	letter-spacing: 0em;
	text-align: left;
}

.importing-box .buttons-head {
	margin: 20px 0 3px 0;
}

.table-container .table-responsive {
	font-size: small;
}

.beneficiarios-import-table-btns{
	text-align: end;
	display: flex;
	align-items: center;
}

.status {
	margin: 0px;
	padding: 3px 10px;
	border-radius: 20px;
	font-size: 12px;
	font-weight: 600;
    text-align: center;
	color: #fff;
	background: #FF612B;
    width: fit-content;
}

.status.invalid {
	background-color: #C40000;
}

.status.valid {
	background-color: #007000;
}

.status.alterado {
	background-color: #196ECF;
}

.editar-importacao-footer {
	margin-top: 24px;
 display: flex;
 align-items: center;
 justify-content: flex-end;
}

@media (max-width: 930px) {
    .import-beneficiarios {
        flex-direction: column;
    }

    .import-beneficiarios-items{
        margin-bottom: 10px;
    }
}

.text-modal {
font-family: optum-sans;
font-size: 16px;
font-weight: 400;
line-height: 24px;
letter-spacing: 0em;
text-align: center;
}

.corrigir-importacao-button {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}

</style>